import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

export interface FileToSend {
  file: File;
  caption?: string;
}

@Component({
  selector: 'app-file-send-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './file-send-modal.component.html',
  styleUrls: ['./file-send-modal.component.scss']
})
export class FileSendModalComponent implements OnInit {
  @Input() selectedFiles: File[] = [];
  @Input() visible: boolean = false;
  @Output() onSend = new EventEmitter<FileToSend[]>();
  @Output() onClose = new EventEmitter<void>();

  filesWithCaptions: FileToSend[] = [];
  message: string = '';

  ngOnInit() {
    this.initializeFiles();
  }

  ngOnChanges() {
    if (this.selectedFiles.length > 0) {
      this.initializeFiles();
    }
  }

  private initializeFiles() {
    this.filesWithCaptions = this.selectedFiles.map(file => ({
      file: file,
      caption: ''
    }));
  }

  closeModal() {
    this.visible = false;
    this.onClose.emit();
  }

  sendFiles() {
    if (this.filesWithCaptions.length === 0) return;

    if (this.message.trim()) {
      this.filesWithCaptions[0].caption = this.message.trim();
    }

    this.onSend.emit(this.filesWithCaptions);
    this.closeModal();
    this.resetForm();
  }

  private resetForm() {
    this.filesWithCaptions = [];
    this.message = '';
  }

  getFilePreview(file: File): string {
    if (this.isImage(file)) {
      return URL.createObjectURL(file);
    }
    return '';
  }

  isImage(file: File): boolean {
    return file.type.startsWith('image/');
  }

  getFileIcon(file: File): string {
    const extension = file.name.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf': return 'pi-file-pdf';
      case 'doc':
      case 'docx': return 'pi-file-word';
      case 'xls':
      case 'xlsx': return 'pi-file-excel';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return 'pi-image';
      case 'zip':
      case 'rar': return 'pi-file-zip';
      default: return 'pi-file';
    }
  }

  getFileSize(size: number): string {
    if (size < 1024) return size + ' B';
    if (size < 1024 * 1024) return Math.round(size / 1024) + ' KB';
    return Math.round(size / (1024 * 1024)) + ' MB';
  }

  removeFile(index: number) {
    this.filesWithCaptions.splice(index, 1);
    if (this.filesWithCaptions.length === 0) {
      this.closeModal();
    }
  }
}
